import { Component } from 'react';
import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
import {
  listAllCountriesOptionArray,
  countryDefinitions
} from 'common/helpers/addresses';
import {
  getOperatingCountryCodes,
  getOperatingStateCodes
} from 'common/helpers/miscHelper';

import AddressFormRow from './AddressFormRow';

class AddressFormBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: props.countryCode
    };
  }

  handleCountryCodeChange = (e) => {
    const { props } = this;
    const countryCode = e.target.value;
    this.setState({ countryCode });
    props.change('stateCode', null);
  };

  render() {
    const { state } = this;
    const { type, settings } = this.props;
    let newSchema;
    let formArray = [];
    let requiredFields = [];
    if (state.countryCode) {
      newSchema = { ...countryDefinitions[state.countryCode].schema };
      if (newSchema.stateCode) {
        const stateCode = { ...newSchema.stateCode };
        newSchema.stateCode = stateCode;
      }
      formArray = countryDefinitions[state.countryCode].formFormat;
      requiredFields = countryDefinitions[state.countryCode].requiredFormFields;
    }
    let countryArray = [];
    if (type === 'Operating') {
      // Limit to operating countries and operating states
      countryArray = listAllCountriesOptionArray(
        false,
        getOperatingCountryCodes(settings)
      );
      const operatingStateCodes = getOperatingStateCodes(settings);
      if (state.countryCode === 'CA' || state.countryCode === 'US') {
        const stateArray = newSchema.stateCode.array.filter((stateObj) =>
          operatingStateCodes.includes(stateObj.value)
        );
        newSchema.stateCode.array = stateArray;
      }
    } else {
      countryArray = listAllCountriesOptionArray(false);
      newSchema = { ...countryDefinitions[state.countryCode].schema };
    }
    return (
      <>
        {renderCountryCodes(countryArray, this.handleCountryCodeChange)}
        {formArray.map((formRow) => (
          <AddressFormRow
            addressArray={formRow}
            schema={newSchema}
            requiredFields={requiredFields}
            key={formRow[0]}
          />
        ))}
      </>
    );
  }
}

const renderCountryCodes = (countryArray, handleCountryCodeChange) => {
  if (countryArray.length === 1) {
    return null;
  }
  return (
    <Field
      name="countryCode"
      component={SelectField}
      optionArray={countryArray}
      label="Country"
      onChange={handleCountryCodeChange}
      required
    />
  );
};

export default AddressFormBlock;
